// UPost - Logo Component
import React from 'react';

export function Logo({ variant = 'full', size = 'md' }) {
  const sizes = {
    sm: { container: 'h-10', text: 'text-xl', image: 'h-10 w-10' },
    md: { container: 'h-14', text: 'text-3xl', image: 'h-14 w-14' },
    lg: { container: 'h-16', text: 'text-4xl', image: 'h-16 w-16' },
    xl: { container: 'h-20', text: 'text-5xl', image: 'h-20 w-20' }
  };

  const sizeClasses = sizes[size];

  // Mark Twain portrait (public domain from Wikimedia)
  const markTwainImage = '/mark-twain-bg.jpg';

  if (variant === 'icon') {
    return (
      <div className={`${sizeClasses.container} ${sizeClasses.image} rounded-full overflow-hidden border-2 border-purple-600 shadow-lg`}>
        <img 
          src={markTwainImage} 
          alt="UPost Logo" 
          className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all"
        />
      </div>
    );
  }

  if (variant === 'full') {
    return (
      <div className="flex items-center gap-3">
        <div className={`${sizeClasses.image} rounded-full overflow-hidden border-2 border-purple-600 shadow-lg bg-white`}>
          <img 
            src={markTwainImage} 
            alt="Mark Twain" 
            className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all"
          />
        </div>
        <div className="flex flex-col">
          <span className={`${sizeClasses.text} font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent`}>
            UPost
          </span>
          <span className="text-xs text-gray-600 -mt-1">Write with AI</span>
        </div>
      </div>
    );
  }

  if (variant === 'minimal') {
    return (
      <div className="flex items-center gap-2">
        <div className={`${sizeClasses.image} rounded-full overflow-hidden border-2 border-purple-600 shadow-md bg-white`}>
          <img 
            src={markTwainImage} 
            alt="UPost" 
            className="w-full h-full object-cover grayscale"
          />
        </div>
        <span className={`${sizeClasses.text} font-bold text-purple-600`}>
          UPost
        </span>
      </div>
    );
  }

  return null;
}

// Logo with multiple authors (Mark Twain + Shakespeare + Woolf) - LARGER SIZE
export function LogoMultiAuthor({ size = 'md' }) {
  const sizes = {
    sm: { container: 'h-10', text: 'text-xl', image: 'h-8 w-8' },
    md: { container: 'h-14', text: 'text-3xl', image: 'h-12 w-12' },
    lg: { container: 'h-16', text: 'text-4xl', image: 'h-14 w-14' },
    xl: { container: 'h-20', text: 'text-5xl', image: 'h-16 w-16' }
  };

  const sizeClasses = sizes[size];

  const authors = [
    {
      name: 'Mark Twain',
      image: '/mark-twain-bg.jpg'
    },
    {
      name: 'Shakespeare',
      image: 'https://images.unsplash.com/photo-1581344895000-b5deedbd1660?w=200&h=200&fit=crop'
    },
    {
      name: 'Virginia Woolf',
      image: 'https://images.unsplash.com/photo-1680356475155-3ca8fa2192aa?w=200&h=200&fit=crop'
    }
  ];

  return (
    <div className="flex items-center gap-3">
      <div className="flex -space-x-3">
        {authors.map((author, index) => (
          <div 
            key={author.name}
            className={`${sizeClasses.image} rounded-full overflow-hidden border-2 border-white shadow-lg bg-white relative`}
            style={{ zIndex: authors.length - index }}
            title={author.name}
          >
            <img 
              src={author.image} 
              alt={author.name} 
              className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all"
            />
          </div>
        ))}
      </div>
      <div className="flex flex-col">
        <span className={`${sizeClasses.text} font-bold bg-gradient-to-r from-purple-600 to-blue-600 bg-clip-text text-transparent`}>
          UPost
        </span>
        <span className="text-xs text-gray-600 -mt-1">Write with AI</span>
      </div>
    </div>
  );
}